export function showBanner(message) {
  const el = document.createElement("div");
  el.className = "welp-banner-overlay";
  const text = document.createElement("div");
  text.className = "welp-banner-text";
  message.split("").forEach((ch, i) => {
    const s = document.createElement("span");
    s.textContent = ch === " " ? "\u00A0" : ch;
    s.style.animationDelay = `${i * 40}ms`;
    text.appendChild(s);
  });
  el.appendChild(text);
  document.body.appendChild(el);
  setTimeout(() => {
    el.classList.add("welp-banner-out");
    setTimeout(() => el.remove(), 700);
  }, 2800);
}
